<template>
    <div class="collapsible-body">
        <div class="row " style="width: 100%;">
            <div class="col s2">{{$t('tranches.enter_codes_quantity')}}</div>
        </div>
        <div class="row " style="width: 100%;">
            <div class="col s2 input-field">
                <input type="text" v-model="tranch_length" />
            </div>
            <div class="col s2">
                <a class="waves-effect waves-light btn-small solidgreen" v-on:click="generateCodes()">
                    <div v-if="tranch_generating" class="preloader-wrapper small active">
                        <div class="spinner-layer spinner-red-only">
                            <div class="circle-clipper left">
                                <div class="circle"></div>
                            </div>
                            <div class="gap-patch">
                                <div class="circle"></div>
                            </div>
                            <div class="circle-clipper right">
                                <div class="circle"></div>
                            </div>
                        </div>
                    </div>
                    {{tranch_generating == false ? $t('tranches.generate_codes') : ""}}
                </a>
            </div>
        </div>
        {{errornotice}}
        <div class="row baseheader qrlist" style="width: 100%;">
            <div class="col s2 input-field" v-on:click="setTranchesOrder('created_at')">
                {{$t('tranches.generated_date')}}
                <i class="material-icons dp6" v-if="ordertranchesby == 'created_at' && ordertranches == 'desc'">arrow_drop_down</i>
                <i class="material-icons dp6" v-if="ordertranchesby == 'created_at' && ordertranches == 'asc'">arrow_drop_up</i>
            </div>
            <div class="col s2 input-field" v-on:click="setTranchesOrder('frac')">
                {{$t('tranches.left_codes')}}
                <i class="material-icons dp6" v-if="ordertranchesby == 'frac' && ordertranches == 'desc'">arrow_drop_down</i>
                <i class="material-icons dp6" v-if="ordertranchesby == 'frac' && ordertranches == 'asc'">arrow_drop_up</i>
            </div>
        </div>
        <div class="row" v-for="tranch in listTranches">
            <div class="col s2">
                {{tranch.created_at | formatDateHourAndMinute}}
            </div>
            <div class="col s2">
                {{tranch.left_codes}} {{$t('tranches.out_of')}} {{tranch.length || 50}}
            </div>
            <div class="col s2">
                <a v-bind:href="'\\tranches\\'+tranch.id+'.pdf'" v-if="tranch.length == 0 || tranch.length == null"><i class="material-icons dp6">print</i></a>
                <a :href='tranch.attachment_url' v-if="tranch.generated"><i class="material-icons dp6">print</i></a>
                {{tranch.generated == false ? $t('tranches.generating')+"..." : ""}}
            </div>
        </div>
        <div>
            <preloader v-if="tranches_loaded == false" n="3" />
        </div>
        <div class="row" v-if="tranches_loaded == true && listTranches.length == 0">
            <div class="col s12">{{$t('tranches.no_codes')}}</div>
        </div>
    </div>
</template>
<script>
import Vue2Filters from 'vue2-filters'
import axios from 'axios';
import _ from 'lodash';
import moment from 'moment'

export default {
    data: function() {
        return {
            tranches: [],
            tranch_generating: false,
            tranches_loaded: false,
            ordertranchesby: "created_at",
            ordertranches: 'desc',
            tranch_length: 50,
            errornotice: "",
            last_loaded: 0
        }
    },
    mounted: function() {
        this.loadTranches();
        this.timer = setInterval(this.tickTranches, 30000);
    },
    beforeDestroy () {
      this.cancelAutoUpdate();
    },
    methods: {
        tickTranches: function(){
            axios.get('/tranches/last.json').then(response => {
                if(response.data > this.last_loaded){
                    this.loadTranches();
                }
            });
        },
        loadTranches: function(){
            axios.get('/tranches.json').then(response => {
                this.tranches = response.data;
                this.tranches_loaded = true;
                for (var i = this.tranches.length - 1; i >= 0; i--) {
                    this.tranches[i].frac = this.tranches[i].left_codes / this.tranches[i].length;
                }
                this.last_loaded = moment().unix();
            });
        },
        setTranchesOrder: function(order) {
            if (this.ordertranchesby == order) {
                if (this.ordertranches == 'desc') {
                    this.ordertranches = 'asc'
                } else if (this.ordertranches == 'asc') {
                    this.ordertranches = 'desc'
                }

            } else {
                this.ordertranchesby = order;
            }
        },
        generateCodes: function() {
            this.errornotice = "";
            this.tranch_generating = true;
            axios.post("/tranches.json", { length: this.tranch_length }).then((response) => {
                this.tranch_generating = false;
                this.tranches.push(response.data)
            }).catch((response) => {
                this.errornotice = response.response.data.notice;
                this.tranch_generating = false;
            })
        },
        cancelAutoUpdate () {
            clearInterval(this.timer);
        }
    },
    
    computed: {
        listTranches() {
            var that = this;
            return _.orderBy(this.tranches, this.ordertranchesby, this.ordertranches);
        },
    },
    filters: {
        formatDateHourAndMinute(value) {
            if (value && moment(value).isValid()) {
                let cleanValue = value.replace('T', ' ').split('.')[0];
                return moment(cleanValue).format('D MMMM YYYY HH:mm');
            }
            return '';
        }
    }
};
</script>
<style scoped>
.solidgreen {
    background-color: #00CC66 !important;
    color: black;
}

.baseheader {
    background-color: #DADADA;
    margin-bottom: 0px;
}

.input-field {
    margin: 0px !important;
}

.qrlist {
    padding-top: 15px;
    padding-bottom: 15px;
}

.qrlist i {
    position: initial !important;
}

.preloader-wrapper.small {
    width: 20px !important;
    height: 20px !important;
}

.input-field {
    margin-top: 0rem;
    margin-bottom: 0rem;
}

.input-field i {
    position: absolute !important;
    right: 15px;
}
</style>